module.exports = __webpack_public_path__ + "assets/img/b123-bo.svg";